import { render, staticRenderFns } from "./lkuLeaveenttl.vue?vue&type=template&id=19a93da0"
import script from "./lkuLeaveenttl.vue?vue&type=script&lang=js"
export * from "./lkuLeaveenttl.vue?vue&type=script&lang=js"
import style0 from "./lkuLeaveenttl.vue?vue&type=style&index=0&id=19a93da0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports